import { __ } from '@wordpress/i18n';
import { useEffect, useRef} from 'react';
import { useSelect } from '@wordpress/data';
import { useState } from '@wordpress/element';
import PanelSettings from './advance/inspector-control';
import AdvanceSettings from './advance';
import Layout from './Layouts/layout';
import { VayuBlocksDevice} from '@vayu-blocks/device-control';
import { store as blockEditorStore } from '@wordpress/block-editor';

export function Edit( {attributes,setAttributes,clientId,isSelected }) {
	  
	const getView = VayuBlocksDevice(); 

	useEffect(() => {
        setAttributes({ uniqueId: `vb-${clientId.substring(0, 8)}` });
    }, [clientId]);
	
	const [layout, setLayout] = useState('layout-1');

	const containerRef = useRef(null); 
	const iconRef = useRef(null);

	const blockInfo = useSelect(
		(select) => {
			const { getBlockIndex, getBlockRootClientId, getBlockOrder } = select('core/block-editor');
			const parentClientId = getBlockRootClientId(clientId);
			const index = getBlockIndex(clientId, parentClientId);
			const total = getBlockOrder(parentClientId)?.length || 0;
	
			return {
				blockIndex: index,
				isLast: index === total - 1,
			};
		},
		[clientId]
	);
	
	useEffect(() => {
		if (blockInfo.blockIndex !== undefined) {
			setAttributes({
				blockIndex_child: blockInfo.blockIndex,
				isLastBlock: blockInfo.isLast,
			});
		}
	}, [blockInfo.blockIndex, blockInfo.isLast]);
	
	const isEvenIndex = blockInfo.blockIndex % 2 === 0;
	const isOddIndex = !isEvenIndex;
	
	const parentBlockAttributes = useSelect((select) => {
        const { getBlockParents, getBlock } = select('core/block-editor');
        const parentIds = getBlockParents(clientId, true);
    
        if (parentIds.length > 0) {
            const parentBlockId = parentIds[0];
            const parentBlockDetails = getBlock(parentBlockId);
            if (parentBlockDetails) {
                return {
                    name: parentBlockDetails.name || null,
                    attributes: parentBlockDetails.attributes || {}
                };
            }
        }
    
        return { name: null, attributes: {} };
    }, [clientId]);

	useEffect(() => {
		if (parentBlockAttributes) {
			const {
				timelinelayout,
				iconName,
				thickness,
				layoutborder,
				layoutradius,
				layoutShadow,
				layoutpadding,
				layoutmargin,
				gapchild,
				thicknesstablet,
				thicknessmobile,
				connector,
				gbadvBackground,
				gbadvBackgroundHover
			} = parentBlockAttributes.attributes;

			setLayout(timelinelayout);

			setAttributes({
				layout_child: timelinelayout,
				printedIcon_child: iconName,
				thickness: thickness,
				layoutborder: layoutborder,
				layoutradius: layoutradius,
				layoutShadow: layoutShadow,
				layoutpadding: layoutpadding,
				layoutmargin: layoutmargin,
				gapchild: gapchild,
				thicknesstablet: thicknesstablet,
				thicknessmobile: thicknessmobile,
				connector: connector,
				gbadvBackground: gbadvBackground,
				gbadvBackgroundHover: gbadvBackgroundHover,
			});
		}
	}, [parentBlockAttributes]);

	const left = parseInt(attributes.layoutborder?.[getView]?.width || attributes.layoutborder?.[getView]?.left?.width || 0);
	const right = parseInt(attributes.layoutborder?.[getView]?.width || attributes.layoutborder?.[getView]?.right?.width || 0);

	const getThicknessByView = () => {
		if (getView === 'Tablet') return attributes.thicknesstablet || attributes.thickness;
		if (getView === 'Mobile') return attributes.thicknessmobile || attributes.thickness;
		return attributes.thickness;
	};
	
	const triggerRerender = useSelect((select) => {
		const block = select(blockEditorStore).getBlock(clientId);
		return block?.attributes;
	}, [clientId]);

	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		const measure = () => {
			// First logic (vb-timeine-content, vb-timeline-date, etc.)
			const contentEl = container.querySelector('.vb-timeine-content');
			const dateEl = container.querySelector('.vb-timeline-date');
			const parentEl = container.querySelector('.vayu_blocks-timeline__parent');
			const connectorEl = container.querySelector('.vayu-blocks-connector-timeline-child');

			if (contentEl && dateEl && parentEl) {
				const contentRect = contentEl.getBoundingClientRect();
				const dateRect = dateEl.getBoundingClientRect();

				const leftRelative = contentRect.width;
				const leftRelative1 = dateRect.width;

				let left = '';

				if (layout === 'layout-1' || (layout === 'layout-4' && isEvenIndex) || (layout === 'layout-3' && isOddIndex)) {
					left = leftRelative;
				} else if (layout === 'layout-2' || (layout === 'layout-4' && isOddIndex) || (layout === 'layout-3' && isEvenIndex)) {
					left = leftRelative1;
				}

				if (left !== '' && (layout === 'layout-1' || layout === 'layout-2'|| layout === 'layout-3'|| layout === 'layout-4')) {
					const calcLeft = `calc(${left}px + 35px)`;
					parentEl.style.left = calcLeft;
					if (connectorEl) connectorEl.style.left = calcLeft;
					setAttributes({ iconleft: left });
				}else if (layout === 'layout-5' || layout === 'layout-6'){
					setAttributes({ iconleft: '' });
				} else {
					setAttributes({ iconleft: '' });
					parentEl.style.left = `revert-layer`;
					if (connectorEl) connectorEl.style.left = `revert-layer`;
				}
			}

			const height = container.offsetHeight;
			const width = container.offsetWidth;

			const currentChild = container.closest('.wp-block-vayu-blocks-timeline-child');
			const nextChild = currentChild?.nextElementSibling?.classList.contains('wp-block-vayu-blocks-timeline-child')
				? currentChild.nextElementSibling
				: null;

			let nextChildHeight = 0;
			let nextChildWidth = 0;
			if (nextChild) {
				nextChildHeight = nextChild.scrollHeight;
				nextChildWidth = nextChild.scrollWidth;
			}

			if (iconRef.current) {
				const iconref = iconRef.current;
				const leftDistance = iconref.offsetLeft;
				const topDistance = iconref.offsetTop;
				const widthDistance = iconref.offsetWidth;
				const heightDistance = iconref.offsetHeight;

				setAttributes({
					containerHeight: height,
					containerWidth: width,
					containerLeft: leftDistance,
					iconTop: topDistance,
					widthDistance: widthDistance,
					HeightDistance: heightDistance,
					nextChildHeight: nextChildHeight,
					nextChildWidth: nextChildWidth,
				});
			}
		};

		const initTimeout = setTimeout(measure, 150);

		const resizeObserver = new ResizeObserver(measure);
		resizeObserver.observe(container);

		const mutationObserver = new MutationObserver(measure);
		mutationObserver.observe(container, { childList: true, subtree: true });

		measure();

		return () => {
			clearTimeout(initTimeout);
			resizeObserver.disconnect();
			mutationObserver.disconnect();
		};
	}, [layout, isEvenIndex, isOddIndex, triggerRerender]);

	return (
		<>

			<PanelSettings attributes={attributes} setAttributes={setAttributes} isSelected={isSelected} clientId={clientId}/>
		
            <AdvanceSettings attributes={attributes} setAttributes={setAttributes} clientId={clientId}>

				<div ref={containerRef} class="vayu_blocks_timeline-child_block_main">
					
					<div style={{position:'relative',height: '100%'}}>
						<Layout
							layout={layout}
							isEvenIndex={isEvenIndex}
							isOddIndex={isOddIndex}
							printedIcon={attributes.iconglobal ? attributes.iconName : attributes.printedIcon_child}
							iconRef={iconRef}
						/>

						{!attributes.isLastBlock &&  attributes.connector && (
							<>
								{['layout-7','layout-8'].includes(layout) && (
									<div
										style={{
											top: `calc(44% + (${attributes.HeightDistance / 2}px) - ${attributes.thickness}px)`,
											width: `calc((${attributes.containerWidth}px / 2 + ${attributes.nextChildWidth}px / 2 + ${left}px + ${right}px + ${attributes.gapchild?.[getView] || 0}px)`
										}}
										className="vayu-blocks-connector-timeline-child vb-width-timeline"
									/> 
								)}

								{['layout-11'].includes(layout) && (
									<div
										style={{
											top: `calc(2% + (${attributes.HeightDistance / 2}px) - ${attributes.thickness}px)`,
											width: `calc((${attributes.containerWidth}px / 2 + ${attributes.nextChildWidth}px / 2 + ${left}px + ${right}px + ${attributes.gapchild?.[getView] || 0}px)`
										}}
										className="vayu-blocks-connector-timeline-child vb-width-timeline"
									/>
								)}


								{['layout-12'].includes(layout) && (
									<div
										style={{top: `calc(100% - (5% + (${attributes.HeightDistance / 2}px) - ${attributes.thickness}px))`,
											width: `calc((${attributes.containerWidth}px / 2 + ${attributes.nextChildWidth}px / 2 + ${left}px + ${right}px + ${attributes.gapchild?.[getView] || 0}px)`
										}}
										className="vayu-blocks-connector-timeline-child vb-width-timeline"
									/>
								)}

								{['layout-1', 'layout-3', 'layout-4'].includes(layout) && (
									<div
										style={{
											left: '50%',
											height: `calc((${attributes.containerHeight}px / 2 + ${attributes.nextChildHeight}px / 2 + ${left}px + ${right}px + ${(attributes.gapchild?.[getView] || 0)}px))`,
											width: `${getThicknessByView()}px`,
											top: '50%',
											transform: 'translateX(-50%)',
										}}
										className="vayu-blocks-connector-timeline-child"
									/>
								)}

								{['layout-2'].includes(layout) && (
									<div
										style={{
											left: '50%',
											height: `calc((${attributes.containerHeight}px / 2 + ${attributes.nextChildHeight}px / 2 + ${left}px + ${right}px + ${(attributes.gapchild?.[getView] || 0)}px))`,
											width: `${getThicknessByView()}px`,
											top: '50%',
											transform: 'translateX(-50%)',
										}}
										className="vayu-blocks-connector-timeline-child"
									/>
								)}

								{['layout-5', 'layout-6'].includes(layout) && (
									<div
										style={{
											left: `${attributes.containerLeft + attributes.widthDistance / 2}px`,
											height: `calc((${attributes.containerHeight}px / 2 + ${attributes.nextChildHeight}px / 2 + ${left}px + ${right}px + ${(attributes.gapchild?.[getView] || 0)}px))`,
											width: `${getThicknessByView()}px`,
											top: '50%',
											transform: 'translateX(-50%)',
										}}
										className="vayu-blocks-connector-timeline-child"
									/>
								)}
							</>
						)} 
					</div>

				</div>

            </AdvanceSettings>
             
		</>
	);
}

export default Edit; 